<template>
    <div>
        <user-menu />
        <div class="wrapper">
            <EnterpriseAdminSidebarMenu :show_menu="false" :show_back_button="true" back_link="enterpriseadminpathway"
            />
            <div class="content-wrapper padding-left-165">
                <div class="container-wrapper center">
          <div>
            <div class="heading-1">
              <h3 class="d-inline heading text-uppercase">Resources</h3>
            </div>
            <div class="clear"></div>
          </div>
          <div class="border-bottom mt-1 mb-2"></div>


            <div class="row top-content"  v-if="loading == true">
            <div class="col-2 p-0 pl-3 padding-t-10">
              <PuSkeleton :count="1"></PuSkeleton>
            </div>
            <div class="col-6 text-right p-0">
              &nbsp;
            </div>
            <div class="col-2 text-right p-0">
              
            </div>
            <div class="col-2 text-right p-0 pr-2">
              <PuSkeleton  height="30px" :count="1"></PuSkeleton>
            </div>
            </div>


          <div class="text-center pt-4" v-if="loading == true">
            <div class="row ml-1" v-for="option in 5">
              <div class="resource-tasklist-heading"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="resource-type-heading padding-l-10"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="resource-heading2 padding-l-10"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="resource-heading3 padding-l-10"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="col-12 p-0 pr-3">
                <div class="custom_hr"></div>
              </div>
            </div>
          </div>



                    <div class="">
                        <flash-message autoHide variant="success"></flash-message>
                        
                    </div>
                    <div  v-if="loading == false">
                        <b-card no-body class="manage_locations">
                            <div>
                                <div class="font-weight-bold resource-subhead">Task Lists</div>
                                <div class="btn btn-primary btn-sm btn-view-report resource-button" @click="openNewResourceRequest">Resource Request</div>
                            </div>
                            <div class="list_locations">
                             <div class="row enterprise-head-row">
                                <div class="resource-tasklist-heading">
                                    Title                                        
                                </div>
                                <div class="resource-type-heading">
                                    Type                                       
                                </div> 
                                <div class="resource-heading2 text-center">
                                    # of Locations using                                        
                                </div> 
                                <div class="resource-heading3 text-center">
                                    # of Mentees using                                      
                                </div> 
                             </div>

                                <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
                                <div v-if="accountTaskLists.length > 0" class="row_items">
                                    <div class="row_data_border row" v-for="(tasklist, tindex) in accountTaskLists" :key="tindex">
                                        <div class="resource-tasklist-text"> {{ tasklist.name }} </div>
                                        <div class="resource-type-text"> {{ tasklist.type }} </div>
                                        <div class="resource-text2 text-center">{{ tasklist.accountCount }}</div>
                                        <div class="resource-text3 text-center">{{ parseInt(tasklist.menteeCount + tasklist.apprenticeCount) }}</div>
                                        <div class="clearfix"></div>
                                    </div>
                                </div>
                                
                            </div>
                        </b-card>
                    </div>
                    <div class="margin-bottom-10"></div>
                    
                    <div  v-if="loading == false">
                        <b-card no-body class="manage_locations">
                            <div>
                                <div class="font-weight-bold resource-subhead">Courses</div>
                                <div class="btn btn-primary btn-sm btn-view-report resource-button" @click="openNewResourceRequest">Resource Request</div>
                            </div>
                            <div class="list_locations">
                                <div class="row enterprise-head-row">
                                    <div
                                        class="resource-heading1">
                                        Title                                        
                                    </div>
                                    <div
                                        class="resource-heading2 text-center">
                                        # of Locations using                                        
                                    </div>
                                    <div
                                        class="resource-heading3 text-center">
                                        # of Mentees using                                      
                                    </div>
                                    
                                </div>
                                <div v-if="accountCourses.length > 0" class="row_items">
                                    <div class="row_data_border row" v-for="(course, cindex) in accountCourses" :key="cindex">
                                        <div class="resource-text1"> {{ course.name}}</div>
                                        <div class="resource-text2 text-center">{{ course.accountCount }}</div>
                                        <div class="resource-text3 text-center">{{ parseInt(course.menteeCount + course.apprenticeCount) }}</div>
                                        
                                        <div class="clearfix"></div>
                                    </div>
                                </div>
                                
                            </div>
                        </b-card>
                    </div>                                
                   <div class="margin-bottom-10"></div>
                   
                     <div  v-if="loading == false">
                        <b-card no-body class="manage_locations">
                            <div>
                                <div class="font-weight-bold resource-subhead">Forms</div>
                                <div class="btn btn-primary btn-sm btn-view-report resource-button" @click="openNewResourceRequest">Resource Request</div>
                            </div>
                            <div class="list_locations">
                                <div class="row enterprise-head-row">
                                    <div
                                        class="resource-heading1">
                                        Title                                        
                                    </div>
                                    <div
                                        class="resource-heading2 text-center">
                                        # of Locations using                                        
                                    </div>
                                    <div
                                        class="resource-heading3 text-center">
                                        # of Mentees using                                      
                                    </div>
                                    
                                </div>
                                <div v-if="accountForms.length > 0" class="row_items">
                                    <div class="row_data_border row" v-for="(form, findex) in accountForms" :key="findex">
                                        <div class="resource-text1"> {{ form.name }}</div>
                                        <div class="resource-text2 text-center">{{ form.accountCount }}</div>
                                        <div class="resource-text3 text-center">{{ parseInt(form.menteeCount + form.apprenticeCount) }}</div>
                                        
                                        <div class="clearfix"></div>
                                    </div>
                                </div>
                                
                            </div>
                        </b-card>
                    </div>
                     <div class="margin-bottom-10"></div>

                     <div  v-if="loading == false">
                        <b-card no-body class="manage_locations">
                            <div>
                                <div class="font-weight-bold resource-subhead">Assessments</div>
                                <div class="btn btn-primary btn-sm btn-view-report resource-button" @click="openNewResourceRequest">Resource Request</div>
                            </div>
                            <div class="list_locations">
                                <div class="row enterprise-head-row">
                                    <div
                                        class="resource-heading1">
                                        Title                                        
                                    </div>
                                    <div
                                        class="resource-heading2 text-center">
                                        # of Locations using                                        
                                    </div>
                                    <div
                                        class="resource-heading3 text-center">
                                        # of Mentees using                                      
                                    </div>
                                    
                                </div>
                                <div v-if="accountAssessments.length > 0" class="row_items">
                                    <div class="row_data_border row" v-for="(assessment, aindex) in accountAssessments" :key="aindex">
                                        <div class="resource-text1"> {{ assessment.name }}</div>
                                        <div class="resource-text2 text-center">{{ assessment.accountCount }}</div>
                                        <div class="resource-text3 text-center">{{ parseInt(assessment.menteeCount + assessment.apprenticeCount) }}</div>
                                        
                                        <div class="clearfix"></div>
                                    </div>
                                </div>
                                
                            </div>
                        </b-card>
                    </div>

                </div>
            </div>
        </div>

       <AddNewEResourceRequest
            :isModalResourceVisible="isModalResourceVisible"             
            @close="closeEnterpriseAdminSidebar"
            ref="add_new_resource_request" 
        />

    </div>
</template>
<script>
import UserMenu from '../shared/user_menu.vue';
import axios from 'axios';
import EnterpriseAdminSidebarMenu from '../shared/enterpriseadmin_sidebar_menu.vue';
import router from '../../router/index.js';
import { store } from '../../store/store';
import AddNewEResourceRequest from './add_new_resourcerequest.vue';

export default {
    data() {
        return {
            loading: false,
            isModalResourceVisible: false,
            primaryManagers: [],
            accountTaskLists: [],
            accountCourses: [],
            accountForms: [],
            accountAssessments: [],
            isReadOnly: false,
        }
    },
    components: {
        UserMenu,
        EnterpriseAdminSidebarMenu,
        AddNewEResourceRequest      
    },   
    methods: {        
        openNewResourceRequest() {
            this.isModalResourceVisible = true;              
        },
        closeEnterpriseAdminSidebar() {
            this.isModalResourceVisible = false;
        },
        getNoRecordText(count) {
            if (this.loading) {
                return '';
            } else {
                if (count == 0 && this.accountId) {
                    return 'No Location Found';
                }
            }
        },        
        goToPrint(){
            router.push('/print-enterprise-locations')
        },
        getEnterpriseAccountsPrimaryManager() {
            axios('/enterprise_accounts_primary_manager_list',
            {
                method: 'GET',
            })
            .then(resp => {
                this.primaryManagers = resp.data;                          
            })
            .catch(() => {
            });
        }
    },
    created() {
        this.loading = true;
        store.dispatch('clear_search_enterprise_locations');
        axios('/enterprise_account_resource_statistics',
        {
            method: 'GET',
        })
        .then(response => {
            this.loading = false;
            this.accountTaskLists = response.data.tasklists;
            this.accountCourses = response.data.courses;
            this.accountForms =  response.data.forms;
            this.accountAssessments = response.data.assessments;            
        })
        .catch(() => {
        });

        if (this.$store.state.enterprise_type === 'Readonly') {
          this.isReadOnly = true;
        } else {
          if (this.$store.state.switch_admin_enterprise_isreadonly) {
            this.isReadOnly = true;
          } else {
            this.isReadOnly = false;
          }
        }
        
    },
}
</script>
<style scoped>
.manage_locations { padding: 1rem 0rem 0rem 0rem; background-color: #FFF !important; }
.list_locations { padding: 0 1rem; margin: 1rem 0; }
.location_header { float: left; font-weight: 900; margin-top: 15px; }
.enterprise-head-row { font-weight: bold;  border-bottom: 4px solid #D1D5D5; color: #002f42; padding-bottom: 5px; }
.row_items { margin-right: -15px; margin-left: -15px; color: #002f42; }
.row_data_border { padding: 5px 0; margin: 10px 0; font-size: 14px;border-bottom: 1px solid #D1D5D5; }
.row_data_border:nth-last-child(1) { border-bottom: 0 none; }
.text-green { color: #28a745 !important; font-weight: 900; }
.text-red { color: #dc3545 !important; font-weight: 900; }
.ea-group-name, .ea-quick-link {
  text-decoration: underline !important;
  cursor: pointer;
}
.heading { padding-left: 0px; }
.overview-icons { color: #bfbfbf; font-size: 1rem; }
.print_icons { font-size: 1.5rem;float: right; margin: 1px 0; color: #000 !important; }

.expired_text { color: green; }
.loading_show { height: auto; }
.resource-subhead { display: inline; margin-left: 0px; font-size: 17px; color: #002f42; }
.resource-button { float: right; }
.btn-view-report {
  color: #FFF !important;
  background-color: #00acee;
  border: 1px solid #00acee;
  border-radius: 15px;
  font-size: 13px;
  padding: 8px 15px;
  line-height: 8px;
  margin: 5px;
}
.btn-view-report:active, .btn-view-report:focus {
  color: #FFF !important;
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
}
.resource-heading1 {
    width: 60%;
    padding-left: 10px;
}
.resource-heading2 {
    width: 18%;
} 
.resource-heading3 {
    width: 14%;
} 
.resource-heading4 {
    width: 18%;
} 
.resource-heading5 {
    width: 10%;
}
.resource-tasklist-heading {
    width: 52%;
    padding-left: 10px;
}
.resource-type-heading {
    width: 8%;
}
.resource-text1 {
    width: 60%;    
    padding-left: 10px;
}
.resource-text2 {
    width: 18%;    
} 
.resource-text3 {
    width: 14%;    
} 
.resource-text4 {
    width: 18%;
} 
.resource-text5 {
    width: 10%;
}
.resource-tasklist-text {
    width: 52%;
    padding-left: 10px;
}
.resource-type-text {
    width: 8%;
}  
.container-wrapper .heading {
    font-size: 24px !important;
    font-weight: normal !important;
}
.heading-1 {
    width: 70%; float: left; text-align: left; 
}
.custom_heading_hr,
.custom_hr {
    width: 100%;
    margin: 5px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

</style>



// WEBPACK FOOTER //
// src/components/enterpriseadmin/enterprise_resource.vue